export const availableAgents = [
  {
    id: 'mina',
    name: 'Mina',
    role: 'Coordinadora de Agenda & Estratega de Ventas',
    status: 'available',
    description: 'Rescate de agenda y gestión 360º',
    features: [
      'Rescate de Agenda proactivo',
      'Asesora de Negocio en tiempo real',
      'Gestión Pre y Post-Visita'
    ],
    image: 'https://static.readdy.ai/image/c11fe3733a927373504823c692bafe5e/b2966a9cf543de5c4e7b9184c16b4e76.png',
    valueProposition: 'Mina elimina los tiempos muertos. Convierte tu agenda en un tetris perfecto, reactivando la semana si detecta baja ocupación. Pasa de tener una "recepción pasiva" a una "máquina de llenar huecos" que además fideliza al paciente antes y después de cruzar tu puerta.'
  },
  {
    id: 'jose',
    name: 'José',
    role: 'Account Manager Omnicanal & Closer de Ventas',
    status: 'available',
    description: 'Ventas 24/7 en todos los canales',
    features: [
      'Omnipresencia en WhatsApp, Email y Web',
      'Memoria Infinita con CRM integrado',
      'Experto en Producto y objeciones'
    ],
    image: 'https://static.readdy.ai/image/c11fe3733a927373504823c692bafe5e/9ccb0a00648c600501172287eba7e4ed.png',
    valueProposition: 'José convierte tu tráfico en dinero 24/7. Transforma curiosos en compradores leales y exprime cada euro que inviertes en marketing. Es el "Super Vendedor" que nunca se cansa, nunca se queja y nunca pierde un lead.'
  },
  {
    id: 'kata',
    name: 'Kata',
    role: 'Analista Financiera Estratégica (CFO)',
    status: 'available',
    description: 'Optimización financiera inteligente',
    features: [
      'Auditoría en Tiempo Real 24/7',
      'Inteligencia de Precios avanzada',
      'Reportes de Acción inmediatos'
    ],
    image: 'https://static.readdy.ai/image/c11fe3733a927373504823c692bafe5e/d265515727ff7c97fecabc49fc5646bb.png',
    valueProposition: 'Kata es una máquina de encontrar dinero oculto en tu propia empresa. Te permite aumentar el beneficio neto sin necesidad de vender más, solo optimizando dónde ganas y dónde pierdes. Pasa de gestionar a ciegas a tener un control financiero brutal.'
  },
  {
    id: 'felix',
    name: 'Félix',
    role: 'Mentor Corporativo & Soporte de Continuidad',
    status: 'available',
    description: 'Formación y continuidad operativa',
    features: [
      'Formador Eficiente de talento',
      'Sustituto de Emergencia operativo',
      'Punto de Verdad empresarial'
    ],
    image: 'https://static.readdy.ai/image/c11fe3733a927373504823c692bafe5e/1e0d4144e67bcc99ccd2039d00eee5c1.png',
    valueProposition: 'Félix cierra la "brecha de contratación": evita que pagues tres sueldos (el nuevo, el del formador y la pérdida de producción) para cubrir un puesto. Garantiza que el conocimiento se quede en la empresa y no en las personas, asegurando una continuidad operativa total pase lo que pase.'
  }
];

export const agentDetails: Record<string, {
  title: string;
  capabilities: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
  benefits: string[];
}> = {
  mina: {
    title: 'Todo lo que Mina puede hacer por ti',
    capabilities: [
      {
        icon: 'ri-calendar-check-line',
        title: 'Rescate de Agenda',
        description: 'No espera a que llamen. Detecta huecos libres y semanas flojas por defecto de continuidad y contacta proactivamente a clientes para llenarlos al instante.'
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Asesora de Negocio',
        description: 'Te alerta en tiempo real de las pérdidas por citas fallidas y te propone soluciones inmediatas para dejar de perder dinero.'
      },
      {
        icon: 'ri-refresh-line',
        title: 'Gestión 360º',
        description: 'Se encarga de toda la información Pre-Visita (preparación) y Post-Visita (cuidados y fidelización), asegurando que el cliente se sienta acompañado siempre.'
      },
      {
        icon: 'ri-customer-service-2-line',
        title: 'Atención Proactiva',
        description: 'Convierte tu recepción pasiva en una máquina activa de llenar huecos y optimizar tu agenda.'
      },
      {
        icon: 'ri-notification-3-line',
        title: 'Alertas Inteligentes',
        description: 'Notificaciones en tiempo real sobre oportunidades de optimización y mejora de ocupación.'
      },
      {
        icon: 'ri-heart-pulse-line',
        title: 'Fidelización Automática',
        description: 'Mantiene el contacto con tus clientes antes y después de cada visita para garantizar su satisfacción.'
      }
    ],
    benefits: [
      'Agenda optimizada al 100%',
      'Reducción de citas fallidas',
      'Fidelización automática de clientes',
      'Alertas de oportunidades en tiempo real',
      'Gestión completa Pre y Post-Visita',
      'Aumento de ingresos por mejor ocupación'
    ]
  },
  jose: {
    title: 'Todo lo que José puede hacer por ti',
    capabilities: [
      {
        icon: 'ri-message-3-line',
        title: 'Omnipresencia',
        description: 'Atiende, nutre y cierra ventas por WhatsApp, Email y Web simultáneamente, sin perder ninguna oportunidad.'
      },
      {
        icon: 'ri-database-2-line',
        title: 'Memoria Infinita',
        description: 'Gestiona pedidos, upsells y recuerda cada detalle del cliente para sincronizarlo con tu CRM al instante.'
      },
      {
        icon: 'ri-lightbulb-line',
        title: 'Experto en Producto',
        description: 'Resuelve dudas técnicas y objeciones complejas sin titubear, como tu mejor vendedor.'
      },
      {
        icon: 'ri-24-hours-line',
        title: 'Disponibilidad 24/7',
        description: 'Nunca pierde un lead. Atiende a tus clientes en cualquier momento del día o la noche.'
      },
      {
        icon: 'ri-arrow-up-line',
        title: 'Upselling Inteligente',
        description: 'Identifica oportunidades de venta adicional y las aprovecha en el momento perfecto.'
      },
      {
        icon: 'ri-team-line',
        title: 'Integración CRM',
        description: 'Sincroniza automáticamente toda la información con tu sistema de gestión de clientes.'
      }
    ],
    benefits: [
      'Ventas 24/7 sin descanso',
      'Conversión máxima de leads',
      'Gestión omnicanal integrada',
      'ROI optimizado en marketing',
      'Upselling automático',
      'CRM siempre actualizado'
    ]
  },
  kata: {
    title: 'Todo lo que Kata puede hacer por ti',
    capabilities: [
      {
        icon: 'ri-search-eye-line',
        title: 'Auditoría en Tiempo Real',
        description: 'Vigila márgenes, proveedores y precios 24/7 para detectar fugas de dinero antes de que impacten.'
      },
      {
        icon: 'ri-price-tag-3-line',
        title: 'Inteligencia de Precios',
        description: 'Te dice exactamente qué productos potenciar y cuáles renegociar para maximizar beneficios.'
      },
      {
        icon: 'ri-file-chart-line',
        title: 'Reportes de Acción',
        description: 'No te da Excels aburridos; te dice qué decisión tomar hoy para ganar más mañana.'
      },
      {
        icon: 'ri-money-dollar-circle-line',
        title: 'Optimización de Márgenes',
        description: 'Identifica dónde estás perdiendo dinero y cómo recuperarlo sin vender más.'
      },
      {
        icon: 'ri-bar-chart-box-line',
        title: 'Análisis Predictivo',
        description: 'Anticipa tendencias financieras y te prepara para tomar decisiones estratégicas.'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Control Total',
        description: 'Visibilidad completa de tu salud financiera en tiempo real, sin sorpresas.'
      }
    ],
    benefits: [
      'Aumento del beneficio neto',
      'Detección de fugas de dinero',
      'Optimización de proveedores',
      'Decisiones basadas en datos',
      'Control financiero total',
      'Reportes accionables inmediatos'
    ]
  },
  felix: {
    title: 'Todo lo que Félix puede hacer por ti',
    capabilities: [
      {
        icon: 'ri-graduation-cap-line',
        title: 'Formador Eficiente',
        description: 'Capacita al nuevo talento sin que tengas que "sacrificar" el tiempo de tus mejores empleados productivos.'
      },
      {
        icon: 'ri-user-settings-line',
        title: 'Sustituto de Emergencia',
        description: 'Si hay una baja o ausencia, Félix conoce todos los procesos y políticas, actuando como suplente temporal para que la operativa no se detenga.'
      },
      {
        icon: 'ri-book-open-line',
        title: 'Punto de Verdad',
        description: 'Es la fuente de información constante y actualizada para toda la empresa. Cualquier duda sobre política o proceso, Félix tiene la respuesta oficial.'
      },
      {
        icon: 'ri-time-line',
        title: 'Onboarding Rápido',
        description: 'Reduce el tiempo de incorporación de nuevos empleados de semanas a días.'
      },
      {
        icon: 'ri-file-list-3-line',
        title: 'Documentación Viva',
        description: 'Mantiene actualizada toda la información de procesos y políticas empresariales.'
      },
      {
        icon: 'ri-shield-user-line',
        title: 'Continuidad Garantizada',
        description: 'Asegura que el conocimiento permanezca en la empresa, no en las personas.'
      }
    ],
    benefits: [
      'Reducción de costos de formación',
      'Continuidad operativa total',
      'Onboarding acelerado',
      'Conocimiento centralizado',
      'Cobertura de ausencias',
      'Independencia de personas clave'
    ]
  }
};

export const purchaseSteps = [
  {
    number: 1,
    title: 'Crea tu cuenta',
    description: 'Regístrate en menos de 2 minutos'
  },
  {
    number: 2,
    title: 'Selecciona tu agente',
    description: 'Elige Mina o cualquier otro agente disponible'
  },
  {
    number: 3,
    title: 'Realiza el pago',
    description: 'Pago seguro con Stripe, PayPal o tarjeta'
  },
  {
    number: 4,
    title: 'Comienza a usar',
    description: 'Acceso inmediato a tu panel de gestión'
  }
];

export const paymentMethods = [
  { name: 'Stripe', logo: 'ri-bank-card-line', featured: true },
  { name: 'PayPal', logo: 'ri-paypal-line', featured: false },
  { name: 'Visa/Mastercard', logo: 'ri-bank-card-2-line', featured: false },
  { name: 'Apple Pay', logo: 'ri-apple-line', featured: false }
];

export const whatWeOffer = [
  {
    icon: 'ri-robot-2-line',
    title: 'Automatización inteligente',
    description: 'Agentes de IA que trabajan por ti las 24 horas del día, automatizando tareas repetitivas y liberando tu tiempo para lo importante'
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Escalabilidad sin límites',
    description: 'Crece sin preocupaciones. Nuestros agentes se adaptan a tu volumen de trabajo sin necesidad de contratar más personal'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Confianza y seguridad',
    description: 'Tecnología de última generación con los más altos estándares de seguridad y privacidad para proteger tu negocio'
  }
];